import React from 'react'
import Sidebar from "./sidebar"
import "./styles/layout.css"

function index({ children }) {
    return (
        <>
            <Sidebar />
            <div className="main">{children}</div>
           
        </>

    )
}

export default index